// extracted by mini-css-extract-plugin
module.exports = {"Checkout":"Checkout_Checkout__1OoAc"};